
import {
  DISH_TYPE,
  DISH_POSITION,
  OneMenuRecommendationData,
  MenuDish
} from "@/types/home";
import RecommenedFoodMenuItem from "./RecommendFoodMenuItem.vue";
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: {
    RecommenedFoodMenuItem
  },
  name: "RecommendFoodMenu",
  props: {
    data: {
      type: OneMenuRecommendationData,
      default: null,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getMainDish = () => {
      NativeClient.sendDebugLog(
        "RecommendFoodMenu getMainDish data=" + JSON.stringify(props.data)
      );
      const dish = props.data ? props.data.getDish(DISH_POSITION.MAIN_DISH) : null;
      NativeClient.sendDebugLog(
        "RecommendFoodMenu getMainDish dish=" + JSON.stringify(dish)
      );
      return dish;
    };
    const getSub1Dish = () => {
      const dish = props.data ? props.data.getDish(DISH_POSITION.SUB1_DISH) : null;
      NativeClient.sendDebugLog(
        "RecommendFoodMenu getSub1Dish dish=" + JSON.stringify(dish)
      );
      return dish;
    };
    const getSub2Dish = () => {
      const dish = props.data ? props.data.getDish(DISH_POSITION.SUB2_DISH) : null;
      NativeClient.sendDebugLog(
        "RecommendFoodMenu getSub2Dish dish=" + JSON.stringify(dish)
      );
      return dish;
    };
    const isShowMainDish = () => {
      const dish = props.data ? props.data.getDish(DISH_POSITION.MAIN_DISH) : null;
      return dish != null;
    };
    const isShowSub1Dish = () => {
      const dish = props.data ? props.data.getDish(DISH_POSITION.SUB1_DISH) : null;
      return dish != null;
    };
    const isShowSub2Dish = () => {
      const dish = props.data ? props.data.getDish(DISH_POSITION.SUB2_DISH) : null;
      return dish != null;
    };
    const isShowSubDish = () => {
      return isShowSub1Dish() || isShowSub2Dish();
    };
    const selectRecipe = (id: number, type: string) => {
      context.emit("select-recipe", id, type);
    }
    return {
      DISH_TYPE,
      getMainDish,
      getSub1Dish,
      getSub2Dish,
      isShowMainDish,
      isShowSubDish,
      isShowSub1Dish,
      isShowSub2Dish,
      selectRecipe
    };
  }
});
